import type { IconSvgObject } from './types';

const MailOpen02Icon: IconSvgObject = [
  ["path", { d: "M2.45501 8.20424L10.91 2.70848C11.5728 2.27767 12.4272 2.27767 13.09 2.70849L21.545 8.20424C21.8288 8.38871 22 8.70421 22 9.04269V19C22 20.1046 21.1046 21 20 21H4C2.89543 21 2 20.1046 2 19V9.04269C2 8.70421 2.17122 8.38871 2.45501 8.20424Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 8.5L6.92787 12.9799C7.29601 13.3146 7.77568 13.5 8.27321 13.5H15.7268C16.2243 13.5 16.704 13.3146 17.0721 12.9799L22 8.5", stroke: "currentColor", strokeWidth: "1.5", key: "1" }]
];

export default MailOpen02Icon;
